(function (angular) {
	'use strict';

	angular
		.module('settingsModule')
		.controller('EditEmailSettings', [
			'globalConfig',
			'SettingsFactory',
			'urlFactory',
			EditEmailSettingsFunction
		]);

	function EditEmailSettingsFunction(
		globalConfig,
		SettingsFactory,
		urlFactory) {

		var emailSettings = this;

		emailSettings.submitEmailUpdate = function() {
			var payload = {email: emailSettings.email};

			SettingsFactory.emailUpdate.set(payload, emailSettings.updateEmailForm)
				.then(function() {
					urlFactory.redirect('/account/email/success');
				}).catch(function() {
					emailSettings.formSubmitted = false;
				});
		};

		emailSettings.$onInit = function() {
			emailSettings.formSubmitted = false;
			angular.extend(emailSettings, globalConfig);
		};
	}
})(window.angular);